// Mock data for spedireonline.net landing page

export const mockShipmentStats = {
  total: 15847,
  inTransit: 2341,
  delivered: 13284,
  delayed: 222
};

export const mockRecentShipments = [
  { id: 'SHP-2024-001', destination: 'Milano', courier: 'DHL', status: 'In transito', date: '2024-01-15' },
  { id: 'SHP-2024-002', destination: 'Roma', courier: 'UPS', status: 'Consegnato', date: '2024-01-15' },
  { id: 'SHP-2024-003', destination: 'Torino', courier: 'FedEx', status: 'In preparazione', date: '2024-01-14' },
  { id: 'SHP-2024-004', destination: 'Napoli', courier: 'GLS', status: 'In transito', date: '2024-01-14' },
  { id: 'SHP-2024-005', destination: 'Bologna', courier: 'BRT', status: 'Consegnato', date: '2024-01-13' }
];

export const mockMonthlyData = [
  { month: 'Gen', shipments: 1200 },
  { month: 'Feb', shipments: 1450 },
  { month: 'Mar', shipments: 1680 },
  { month: 'Apr', shipments: 1890 },
  { month: 'Mag', shipments: 2100 },
  { month: 'Giu', shipments: 2350 }
];

export const mockCourierComparison = [
  { courier: 'DHL', price: 12.50, time: '24h' },
  { courier: 'UPS', price: 11.80, time: '48h' },
  { courier: 'FedEx', price: 13.20, time: '24h' },
  { courier: 'GLS', price: 9.90, time: '72h' },
  { courier: 'BRT', price: 10.50, time: '48h' }
];

export const mockFormSubmit = (formData) => {
  console.log('Form submitted (MOCK):', formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Richiesta inviata con successo!' });
    }, 1000);
  });
};